export const hashPrefix = 'h2';

export const BACKSLASH_CHAR_REPLACEMENT = '&backslash;';
export const UNDERSCORE_CHAR_REPLACEMENT = '&#95;';

/**
 * Do not reorder the entries here - sort by specificity, with more specific entries at the top.
 * E.g. "this is a text with_underscore" -> "this_is_a_text_with&#95;underscore"
 *   and rearranging entries will yield "this_is_a_text_with_underscore" or "this&#95;is&#95;a&#95;text&#95;with&#95;underscore"
 * If more odd symbols need to be handled, add them here, likely at the top.
 */
export const awkwardSymbolReplacementMap = [
  { human: '\\', machine: BACKSLASH_CHAR_REPLACEMENT },
  { human: '_', machine: UNDERSCORE_CHAR_REPLACEMENT },
  { human: ' ', machine: '_' },
] as const;
